import { render } from "./MatrixLimosDriverRegistration.vue?vue&type=template&id=8d1d9120&scoped=true"
import script from "./MatrixLimosDriverRegistration.vue?vue&type=script&lang=js"
export * from "./MatrixLimosDriverRegistration.vue?vue&type=script&lang=js"

import "./MatrixLimosDriverRegistration.vue?vue&type=style&index=0&id=8d1d9120&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1d9120"]])

export default __exports__